<template><section>

<h1>CheckboxList 复选框组</h1>
<h2>基本用法</h2>
<p>与单个的checkbox不同的是,复选框组通过v-model绑定一个数组(Array),是所有选中的key值</p>
<demo-block>
                    <div class="source" slot="source"><nt-checkbox-list v-model="kjlist">
            <nt-checkbox value="facebook" :disabled="true">facebook</nt-checkbox>
            <nt-checkbox value="github">github</nt-checkbox>
            <nt-checkbox value="google">google</nt-checkbox>
</nt-checkbox-list>
<p>当前选中复选框组的key值:{{kjlist}}</p>



</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-checkbox-list</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"kjlist"</span>&gt;</span>
            <span class="hljs-tag">&lt;<span class="hljs-name">nt-checkbox</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"facebook"</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span>&gt;</span>facebook<span class="hljs-tag">&lt;/<span class="hljs-name">nt-checkbox</span>&gt;</span>
            <span class="hljs-tag">&lt;<span class="hljs-name">nt-checkbox</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"github"</span>&gt;</span>github<span class="hljs-tag">&lt;/<span class="hljs-name">nt-checkbox</span>&gt;</span>
            <span class="hljs-tag">&lt;<span class="hljs-name">nt-checkbox</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"google"</span>&gt;</span>google<span class="hljs-tag">&lt;/<span class="hljs-name">nt-checkbox</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">nt-checkbox-list</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>当前选中复选框组的key值:{{kjlist}}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>{
    data(){
        <span class="hljs-keyword">return</span> {
          <span class="hljs-attr">list</span>:[<span class="hljs-string">'tmall'</span>]
        }
    }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>


</code></pre>
</div></demo-block>
<h2>绑定change事件</h2>
<p>可以绑定change事件来监听复选框的改变,默认传递参数为复选框组中所有选中项的key值</p>
<demo-block>
                    <div class="source" slot="source"><nt-checkbox-list v-model="list" @change="handChange">
            <nt-checkbox value="taobao">taobao</nt-checkbox>
            <nt-checkbox value="tmall">tmall</nt-checkbox>
</nt-checkbox-list>




</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-checkbox-list</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"list"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"handChange"</span>&gt;</span>
            <span class="hljs-tag">&lt;<span class="hljs-name">nt-checkbox</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"taobao"</span>&gt;</span>taobao<span class="hljs-tag">&lt;/<span class="hljs-name">nt-checkbox</span>&gt;</span>
            <span class="hljs-tag">&lt;<span class="hljs-name">nt-checkbox</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"tmall"</span>&gt;</span>tmall<span class="hljs-tag">&lt;/<span class="hljs-name">nt-checkbox</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">nt-checkbox-list</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>{
    data(){
        <span class="hljs-keyword">return</span> {
          <span class="hljs-attr">list</span>:[<span class="hljs-string">'tmall'</span>]
        }
    },
    <span class="hljs-attr">methods</span>:{
      handChange(list){
        alert(<span class="hljs-string">`当前选中的复选框组的key是<span class="hljs-subst">${list}</span>`</span>)
      }
    }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>



</code></pre>
</div></demo-block>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:center">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">Change</td>
<td style="text-align:left">监听复选框组改变的事件</td>
<td style="text-align:center">新数组(Array),是所有选中的key值</td>
</tr>
</tbody>
</table>
</section></template>
<style>
    p{
        font-size:14px;
    }
</style>
<script>
export default{
    data(){
        return {
            list:['tmall'],
            kjlist:['github'],
        }
    },
     methods:{
      handChange(list){
        alert(`当前选中的复选框组的key是${list}`)
      }
    }
}
</script>